(function () {
  'use strict';

  function initAthletesGrid(sectionEl) {
    if (!sectionEl) {
      sectionEl = document.querySelector('.armada-athletes-grid-section');
    }
    if (!sectionEl) return;

    var grid = sectionEl.querySelector('.armada-athletes-grid__list');
    if (!grid) return;

    var allItems = Array.from(grid.querySelectorAll('.armada-athletes-grid__item'));
    var tabs = sectionEl.querySelectorAll('.armada-athletes-filters__tab');
    var tabArray = Array.from(tabs);
    var selects = sectionEl.querySelectorAll('.armada-athletes-filters__select');
    var loadMoreBtn = sectionEl.querySelector('.armada-athletes-pagination__load-more');
    var resultsText = sectionEl.querySelector('.armada-athletes-pagination__results');
    var emptyState = sectionEl.querySelector('.armada-athletes-grid__empty');
    var paginationWrapper = sectionEl.querySelector('.armada-athletes-pagination');
    var itemsPerPage = parseInt(sectionEl.dataset.itemsPerPage, 10) || 12;

    var activeCategory = 'all';
    var activeGender = 'all';
    var activeCountry = 'all';
    var visibleCount = itemsPerPage;

    function getFilteredItems() {
      return allItems.filter(function (item) {
        var cat = (item.dataset.category || '').toLowerCase();
        var gen = (item.dataset.gender || '').toLowerCase();
        var cntry = (item.dataset.country || '').toLowerCase();

        var catMatch = activeCategory === 'all' || cat === activeCategory;
        var genMatch = activeGender === 'all' || gen === activeGender;
        var cntryMatch = activeCountry === 'all' || cntry === activeCountry;

        return catMatch && genMatch && cntryMatch;
      });
    }

    function focusFirstVisibleCard() {
      var firstVisible = grid.querySelector('.armada-athletes-grid__item:not([data-hidden]):not([data-filtered]) a');
      if (firstVisible) {
        firstVisible.focus({ preventScroll: true });
      }
    }

    function applyFilters(moveFocus) {
      var filteredItems = getFilteredItems();
      var filteredTotal = filteredItems.length;

      allItems.forEach(function (item) {
        item.setAttribute('data-filtered', 'true');
        item.setAttribute('data-hidden', 'true');
      });

      filteredItems.forEach(function (item, index) {
        item.removeAttribute('data-filtered');
        if (index < visibleCount) {
          item.removeAttribute('data-hidden');
        } else {
          item.setAttribute('data-hidden', 'true');
        }
      });

      updatePagination(filteredTotal);
      updateEmptyState(filteredTotal);

      // Update tabpanel's aria-labelledby to the active tab. AAS-5226: the
      // tabpanel role moved from the <ul> to a wrapper div (the ul keeps its
      // native list semantics), so resolve the panel from the grid.
      var activeTab = sectionEl.querySelector('.armada-athletes-filters__tab--active');
      var panel = (grid.closest && grid.closest('[role="tabpanel"]')) || grid;
      if (activeTab && activeTab.id && panel.id) {
        panel.setAttribute('aria-labelledby', activeTab.id);
      }

      // Move focus if the previously focused element is now hidden
      if (moveFocus) {
        var active = document.activeElement;
        if (active && active.closest && active.closest('[data-hidden="true"], [data-filtered="true"]')) {
          focusFirstVisibleCard();
        }
      }
    }

    // Category tabs — click
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('armada-athletes-filters__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('armada-athletes-filters__tab--active');
        tab.setAttribute('aria-selected', 'true');
        activeCategory = tab.dataset.filterCategory;
        visibleCount = itemsPerPage;
        applyFilters(true);
      });
    });

    // Category tabs — arrow key navigation
    tabs.forEach(function (tab, index) {
      tab.addEventListener('keydown', function (e) {
        var targetIndex = null;
        if (e.key === 'ArrowRight') targetIndex = (index + 1) % tabArray.length;
        if (e.key === 'ArrowLeft') targetIndex = (index - 1 + tabArray.length) % tabArray.length;
        if (e.key === 'Home') targetIndex = 0;
        if (e.key === 'End') targetIndex = tabArray.length - 1;
        if (targetIndex !== null) {
          e.preventDefault();
          tabArray[targetIndex].focus();
          tabArray[targetIndex].click();
        }
      });
    });

    // Dropdown filters
    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        var filterType = select.dataset.filterType;
        var value = select.value;

        if (filterType === 'gender') activeGender = value;
        if (filterType === 'country') activeCountry = value;

        visibleCount = itemsPerPage;
        applyFilters(true);
      });
    });

    // Load more
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        var filteredItems = getFilteredItems();
        var prevCount = visibleCount;
        visibleCount = Math.min(visibleCount + itemsPerPage, filteredItems.length);

        filteredItems.forEach(function (item, index) {
          if (index < visibleCount) {
            item.removeAttribute('data-hidden');
          }
        });

        updatePagination(filteredItems.length);

        // Focus the first newly revealed card
        if (filteredItems[prevCount]) {
          var firstNewCard = filteredItems[prevCount].querySelector('a');
          if (firstNewCard) firstNewCard.focus({ preventScroll: true });
        }
      });
    }

    function updatePagination(filteredTotal) {
      var shown = Math.min(visibleCount, filteredTotal);

      if (resultsText) {
        var template = resultsText.dataset.resultsTemplate || 'showing {shown} out of {total} results';
        resultsText.textContent = template.replace('{shown}', shown).replace('{total}', filteredTotal);
      }

      if (loadMoreBtn) {
        loadMoreBtn.style.display = shown >= filteredTotal ? 'none' : '';
      }

      if (paginationWrapper) {
        paginationWrapper.style.display = filteredTotal === 0 ? 'none' : '';
      }
    }

    function updateEmptyState(filteredTotal) {
      if (emptyState) {
        emptyState.style.display = filteredTotal === 0 ? 'block' : 'none';
      }
      if (grid) {
        grid.style.display = filteredTotal === 0 ? 'none' : '';
      }
    }

    // Initial render
    applyFilters(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAthletesGrid();
    });
  } else {
    initAthletesGrid();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section.querySelector('.armada-athletes-grid__list')) {
      initAthletesGrid(section);
    }
  });
})();
